import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Empty, Input, Modal, Row, Select, Table, Form } from "antd";
import {useContext, useRef, useState} from "react";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { DocumentoAdministrativo, PostDocumentoAdministrativo } from "../../../../models/Maestras/maestras.model";
import { openNotification } from "../../../../utils/Notifactions";
import {TemplateContext} from "../../../../utils/template_context";

interface IModalDocAdmin {
    openModal: boolean,
    setOpenModal: Function,
    documentosAdministrativos: DocumentoAdministrativo[],
    isEdit: boolean,
    obtenerDocAdministrativos: Function,
    datosDocumento: DocumentoAdministrativo,
    setDatosDocumento: Function
}

export const ModalDocAdmin = ({ openModal, setOpenModal, documentosAdministrativos, isEdit, obtenerDocAdministrativos, datosDocumento, setDatosDocumento }: IModalDocAdmin) => {

    const formRef = useRef<any>();
    const context = useContext(TemplateContext);
    const onCancel = () => {
        setOpenModal(false)
        if (!isEdit) {
            formRef.current.resetFields();
            setDocumentoAdministrativo({
                ...documentoAdministrativo,
                nombre: ''
            })
        }
    }

    const [documentoAdministrativo, setDocumentoAdministrativo] = useState<PostDocumentoAdministrativo>({
        nombre: '',
        tipo_participante_id: null,
    })

    const addArea = async () => {
        if (documentoAdministrativo.nombre !== '' && documentoAdministrativo.tipo_participante_id !== null) {
            try {
                const data = await apiMaestras.crearDocumentoAdministrativo(documentoAdministrativo);
                if (!data?.ok) {
                    return openNotification({
                        titulo: "Error",
                        descripcion: data.message,
                        placement: "bottomRight",
                    })
                }
                obtenerDocAdministrativos();
                formRef.current.resetFields();
                setDocumentoAdministrativo({
                    ...documentoAdministrativo,
                    nombre: ''
                })
            } catch (error) {
                console.log(error)
            }
        }

    }

    const columns: any = [
        {
            title: "Nombre documento administrativo",
            key: "documento",
            dataIndex: "documento",
            //  fixed: context.device === "md"? "left": false,
            width: 200,
        },
        {
            title: "Tipo de perfil",
            key: "tipo_participante",
            dataIndex: "tipo_participante",
            //  fixed: context.device === "md"? "left": false,
            width: 2000,
        },
        {
            title: (
                <div>
                    <div className="titleAcciones">Acciones</div>
                    <div className="controls">
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Editar
                        </div>
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Eliminar
                        </div>
                    </div>
                </div>
            ),
            key: 'actions',
            width: 150,
            fixed: context.device === "lg"? "right": false,
            render: (datos: DocumentoAdministrativo) => (
                <div className="controls">
                    <EditOutlined onClick={() => editDocumento(datos)} />
                    <DeleteOutlined onClick={() => deleteDocumento(datos)} />
                </div>
            )
        },
    ]

    const [modalVisible, setModalVisible] = useState(false);
    const [datosdocAdmin, setDatosdocAdmin] = useState<DocumentoAdministrativo>({
        id: 0,
        documento: '',
        tipo_participante: '',
        fecha_creacion: '',
        tipo_participante_id: 0
    })
    const editDocumento = (datos: DocumentoAdministrativo) => {

        let payload: DocumentoAdministrativo = {
            ...datos,
            nombre: datos.documento,
            tipo_participante_id: ({"Persona natural": 1, "Persona juridica": 2} as Record<string,number>)[datos.tipo_participante] ?? 3
        }

        setDatosdocAdmin(payload);
        setModalVisible(true);
    }

    const deleteDocumento = async (datos: DocumentoAdministrativo) => {
        try {
            const resp = await apiMaestras.eliminarDocumentoAdministrativo(datos.id);
            if (!resp.ok) {
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                });
            }
            obtenerDocAdministrativos();
        } catch (error) {
            console.log(error)
        }
    }

    const actulizarDocumentoAdmin = async () => {
        if (datosdocAdmin.nombre !== '') {
            try {
                const resp = await apiMaestras.actualizarDocumentoAdministrativo(datosdocAdmin);
                if (!resp.ok) {
                    return openNotification({
                        titulo: "Error",
                        descripcion: resp.message,
                        placement: "bottomRight",
                    });
                }
                obtenerDocAdministrativos();
                setModalVisible(false);
            } catch (error) {
                console.log(error)
            }
        }
    }

    const guardarTodo = () => {
        obtenerDocAdministrativos();
        onCancel();

    }

    const guardarEdicion = async () => {


        if (datosDocumento.nombre !== '') {
            try {
                const resp = await apiMaestras.actualizarDocumentoAdministrativo(datosDocumento);
                if (!resp) {
                    return openNotification({
                        titulo: "Error",
                        descripcion: resp.message,
                        placement: "bottomRight",
                    });
                }
                obtenerDocAdministrativos();
                setOpenModal(false);
            } catch (error) {
                console.log(error);
            }
        }
    }

    return (
        <>
            <Modal
                title={
                    <>
                        {isEdit
                            ?
                            (
                                <div>Editar documento administrativo</div>
                            )
                            :
                            (
                                <div>Crear documento administrativo</div>

                            )
                        }
                    </>
                }
                visible={openModal}
                onCancel={onCancel}
                width={1000}
                footer={
                    <>
                        {isEdit
                            ?
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarEdicion}>Guardar y Finalizar</Button>
                                    </Col>
                                </Row>
                            )
                            :
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarTodo}>Cerrar</Button>
                                    </Col>
                                </Row>
                            )
                        }
                    </>
                }
            >
                {isEdit
                    ? (
                        <Row gutter={[24, 24]}>
                            <Col span={12}>
                                <Form.Item name="nombre">
                                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                        Nombre documento administrativo
                                    </span>
                                    <Input name="nombre" value={datosDocumento.nombre} onChange={(e) => setDatosDocumento({ ...datosDocumento, nombre: e.target.value })} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="tipo_perfil">
                                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                        Tipo pefil
                                    </span>
                                    <Select placeholder="Seleccionar..." style={{ width: '100%' }} value={datosDocumento.tipo_participante_id} onChange={(value) => setDatosDocumento({ ...datosDocumento, tipo_participante_id: value })}>
                                        <Select.Option value={1}>Persona natural</Select.Option>
                                        <Select.Option value={2}>Persona juridica</Select.Option>
                                        <Select.Option value={3}>Grupo conformado</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    )
                    :
                    (
                        <>
                            <Form ref={formRef}>
                                <Row gutter={[24, 24]}>
                                    <Col span={12}>
                                        <Form.Item name="nombre">
                                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                                Nombre documento administrativo
                                            </span>
                                            <Input name="nombre" value={documentoAdministrativo.nombre} onChange={(e) => setDocumentoAdministrativo({ ...documentoAdministrativo, nombre: e.target.value })} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name="tipo_perfil">
                                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                                Asociar tipo pefil
                                            </span>
                                            <Select placeholder="Seleccionar..." style={{ width: '100%' }} onChange={(value) => setDocumentoAdministrativo({ ...documentoAdministrativo, tipo_participante_id: value })}>
                                                <Select.Option value={1}>Persona natural</Select.Option>
                                                <Select.Option value={2}>Persona jurídica</Select.Option>
                                                <Select.Option value={3}>Grupo conformado</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                            <Row justify="end">
                                <Col>
                                    <Button className="button-azul-radius" onClick={addArea}>Guardar</Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div>Documentos administrativos creados</div>
                                </Col>
                                <Col>
                                    <Table
                                        dataSource={documentosAdministrativos}
                                        columns={columns}
                                        locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                                        style={{ borderTop: "1px solid #C4C4C4" }}
                                        size="small"
                                        bordered={false}
                                        pagination={false}
                                        scroll={{ x: 1500, y: 300 }}
                                    />
                                </Col>
                            </Row>
                        </>
                    )
                }
            </Modal>
            {modalVisible &&
                <Modal
                    title="Editar documento administrativo"
                    visible={modalVisible}
                    onCancel={() => setModalVisible(false)}
                    width={1000}
                    footer={
                        <Row justify="end" gutter={[24, 24]}>
                            <Col>
                                <Button className="button-blanco-radius" onClick={() => setModalVisible(false)}>Cancelar</Button>
                            </Col>
                            <Col>
                                <Button className="button-azul-radius" onClick={actulizarDocumentoAdmin}>Guardar y Finalizar !!</Button>
                            </Col>
                        </Row>
                    }
                >
                    <Row gutter={[24, 24]}>
                        <Col span={12}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Nombre documento administrativo
                            </span>
                            <Input value={datosdocAdmin.nombre} onChange={(e) => setDatosdocAdmin({ ...datosdocAdmin, nombre: e.target.value })} />
                        </Col>
                        <Col span={12}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Tipo de perfil
                            </span>
                            <Select placeholder="Seleccionar..." style={{ width: '100%' }} value={datosdocAdmin.tipo_participante_id} onChange={(value) => { setDatosdocAdmin({ ...datosdocAdmin, tipo_participante_id: value }) }}>
                                <Select.Option value={1}>Persona natural</Select.Option>
                                <Select.Option value={2}>Persona juridica</Select.Option>
                                <Select.Option value={3}>Grupo conformado</Select.Option>
                            </Select>
                        </Col>
                    </Row>

                </Modal>
            }
        </>
    )

}